
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SolicitudesAdmin.css";
import API from "../api";

export default function SolicitudesAdmin() {
  const navigate = useNavigate();

  const [solicitudes, setSolicitudes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [procesandoId, setProcesandoId] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [errorAccion, setErrorAccion] = useState("");

  useEffect(() => {
    const obtenerSolicitudes = async () => {
      try {
        const respuesta = await fetch(
          `${API}/solicitudes`
        );

        if (!respuesta.ok) {
          throw new Error("No se pudieron cargar las solicitudes");
        }

        const datos = await respuesta.json();
        setSolicitudes(datos);
      } catch (err) {
        setError(err.message);
      } finally {
        setCargando(false);
      }
    };

    obtenerSolicitudes();
  }, []);

  const formatoMoneda = (valor) => {
    return `Q${Number(valor).toFixed(2)}`;
  };

  const cambiarEstado = async (idSolicitud, nuevoEstado) => {
    const accion =
      nuevoEstado === "Aprobada" ? "aprobar" : "rechazar";

    const confirmar = window.confirm(
      `¿Estás seguro de que deseas ${accion} la solicitud #${idSolicitud}?`
    );

    if (!confirmar) return;

    setProcesandoId(idSolicitud);
    setMensaje("");
    setErrorAccion("");

    try {
      const respuesta = await fetch(
        `${API}/solicitudes/${idSolicitud}/estado`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            estado: nuevoEstado
          })
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo actualizar la solicitud"
        );
      }

      setSolicitudes((anteriores) =>
        anteriores.map((solicitud) =>
          solicitud.id_solicitud === idSolicitud
            ? { ...solicitud, estado: nuevoEstado }
            : solicitud
        )
      );

      setMensaje(
        `Solicitud #${idSolicitud} ${nuevoEstado.toLowerCase()} correctamente.`
      );
    } catch (err) {
      console.error("Error al actualizar solicitud:", err);
      setErrorAccion(err.message);
    } finally {
      setProcesandoId(null);
    }
  };

  const confirmarEntrega = async (idSolicitud) => {
    const confirmar = window.confirm(
      `¿Confirmas que entregaste el dinero de la solicitud #${idSolicitud} al conductor?`
    );

    if (!confirmar) return;

    setProcesandoId(idSolicitud);
    setMensaje("");
    setErrorAccion("");

    try {
      const token = sessionStorage.getItem("token");

      const respuesta = await fetch(
      `${API}/solicitudes/${idSolicitud}/entregar`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo confirmar la entrega"
        );
      }

      setSolicitudes((anteriores) =>
        anteriores.map((solicitud) =>
          solicitud.id_solicitud === idSolicitud
            ? { ...solicitud, estado: "Entregada" }
            : solicitud
        )
      );

      setMensaje(
        `Entrega de viáticos de la solicitud #${idSolicitud} confirmada correctamente.`
      );
    } catch (err) {
      console.error("Error al confirmar entrega:", err);
      setErrorAccion(err.message);
    } finally {
      setProcesandoId(null);
    }
  };

  const claseEstado = (estado) => {
    const clases = {
      Pendiente: "estado-pendiente",
      Aprobada: "estado-aprobada",
      Rechazada: "estado-rechazada",
      Entregada: "estado-entregada"
    };

    return clases[estado] || "";
  };


return (
  <div className="solicitudes-admin">

    <div className="solicitudes-boton-superior">
      <button
        type="button"
        className="solicitudes-volver-dashboard"
        onClick={() => navigate("/dashboard")}
      >
        ← Volver al Dashboard
      </button>
    </div>

    <h1>Solicitudes de viáticos</h1>


      <p>
        Administración de solicitudes realizadas por los
        conductores de Transportes Figueroa.
      </p>

      {mensaje && (
        <p className="mensaje-exito" role="status">
          {mensaje}
        </p>
      )}

      {errorAccion && (
        <p className="mensaje-error" role="alert">
          {errorAccion}
        </p>
      )}

      {cargando && <p>Cargando solicitudes...</p>}

      {error && (
        <p className="mensaje-error" role="alert">
          {error}
        </p>
      )}

      {!cargando && !error && solicitudes.length === 0 && (
        <div className="solicitudes-tabla-contenedor">
          <p>No existen solicitudes registradas.</p>
        </div>
      )}

      {!cargando && !error && solicitudes.length > 0 && (
        <div className="solicitudes-tabla-contenedor">
          <table className="solicitudes-tabla">
            <thead>
              <tr>
                <th>ID</th>
                <th>Conductor</th>
                <th>Vehículo</th>
                <th>Ruta</th>
                <th>Días</th>
                <th>Combustible</th>
                <th>Alimentación</th>
                <th>Total</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {solicitudes.map((solicitud) => (
                <tr key={solicitud.id_solicitud}>
                  <td>#{solicitud.id_solicitud}</td>

                  <td>{solicitud.conductor}</td>

                  <td>
                    {solicitud.vehiculo} - {solicitud.marca}
                  </td>

                  <td>
                    {solicitud.origen} → {solicitud.destino}
                  </td>

                  <td>{solicitud.dias_viaje}</td>

                  <td>
                    {formatoMoneda(solicitud.total_combustible)}
                  </td>

                  <td>
                    {formatoMoneda(solicitud.total_alimentacion)}
                  </td>

                  <td>
                    <strong>
                      {formatoMoneda(solicitud.total_viaticos)}
                    </strong>
                  </td>

                  <td>
                    <span
                      className={`estado-solicitud ${claseEstado(
                        solicitud.estado
                      )}`}
                    >
                      {solicitud.estado}
                    </span>
                  </td>

                  <td>
                    {solicitud.estado === "Pendiente" ? (
                      <div className="acciones-solicitud">
                        <button
                          type="button"
                          className="boton-solicitud boton-aprobar"
                          onClick={() =>
                            cambiarEstado(
                              solicitud.id_solicitud,
                              "Aprobada"
                            )
                          }
                          disabled={procesandoId !== null}
                        >
                          {procesandoId === solicitud.id_solicitud
                            ? "Procesando..."
                            : "Aprobar"}
                        </button>

                        <button
                          type="button"
                          className="boton-solicitud boton-rechazar"
                          onClick={() =>
                            cambiarEstado(
                              solicitud.id_solicitud,
                              "Rechazada"
                            )
                          }
                          disabled={procesandoId !== null}
                        >
                          Rechazar
                        </button>
                      </div>
                    ) : solicitud.estado === "Aprobada" ? (
                      <button
                        type="button"
                        className="boton-solicitud boton-entregar"
                        onClick={() =>
                          confirmarEntrega(solicitud.id_solicitud)
                        }
                        disabled={procesandoId !== null}
                      >
                        {procesandoId === solicitud.id_solicitud
                          ? "Procesando..."
                          : "Confirmar entrega"}
                      </button>
                    ) : (
                      <span>
                        {solicitud.estado === "Entregada"
                          ? "Dinero entregado"
                          : "Revisada"}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}


    </div>
  );
}
